<template>
  <div class="pages flex flex-direction align-center justify-start" style="margin: 0 auto;">
    <div class="tips">
      iOS用户三种方式均可购买<br/>
      1.iOS用户可截图或长按图片发送至微信聊天后，微信扫二维码购买；<br/>
      2.点击下方“复制购买链接”至微信聊天后，点击链接购买；
      <div @click="services">3.联系客服购买 <span class="text-blue">→</span></div>
    </div>
    <div class="qrcode-box flex flex-direction align-center justify-start">
      <img :src="qrcodeUrl" class="qrcode">
      <div class="qrcode-txt">微信扫一扫购买</div>
    </div>
    <div class="button-views flex flex-direction align-center justify-start">
      <div class="button-link" @click="copy">复制购买链接</div>
      <div class="button-save" @click="save">保存购买二维码</div>
    </div>
    <services ref="services"></services>
  </div>
</template>

<script>
  import vue from 'vue'
  import services from '../components/service-dialog.vue'
  export default {
    components: {
      services,
    },
    data () {
      return {
        versionKey:'version',
        qrcodeUrl:'',
      }
    },
    methods: {
      copy(){
        let createInput = document.createElement("input");
        createInput.value = 'https://pfotoo.com/#/'+this.versionKey;
        document.body.appendChild(createInput);
        createInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        createInput.style.display = "none";
        vue.toastSuccess("链接复制成功")
        //this.$message({ message: "链接复制成功", type: "success" });
      },
      save(){
        this.download(this.qrcodeUrl,this.versionKey+'.png').then(res=>{
          vue.toastSuccess("保存成功")
        })
      },
      async download(url,filename){
        let res=await wxlite.request({
          url:url,
          method: 'GET',
          //data:data,
          //params:data,
          //body:data,
          headers: {'content-type':'application/x-www-form-urlencoded'},
          responseType: 'arraybuffer',
        })
        console.log(res)
        let type=res.headers['content-type']
        let data=res.data
        let blob = new Blob([data], {type: type})
        //let blob = new Blob([data]);
        let aurl = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = aurl
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        //console.log('download',res.body.byteLength,res.headers.map['content-type'])
        return {size:res.headers['content-length'],name:filename,type: type}
      },
      services(){
        this.$refs.services.show({imgSrc:'https://assets.pfotoo.com/images/qrcode-qy-1221.png'})
      },
    },
    created(){

    },
    mounted(){
      this.versionKey=this.$route.params.action||'version'
      this.qrcodeUrl='https://assets.pfotoo.com/images/version/'+this.versionKey+'.png?v=1'
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  div.pages{
    background-color: #F1DAB9;
    width: 375px;
    padding: 20px 0 140px;
    height: 100vh;
    overflow-y: auto;
  }
  .button-views{
    position: fixed;
    bottom: 0;
    width: 375px;
    height: 100px;
    background: #FFFFFF;
    box-shadow: 0 0 2px 0 #e0e0e080;
    border-radius: 15px 15px 0 0;

  }
  .tips{
    padding-left: 20px;
    padding-right: 8px;
    color: #875a25;
    font-size: 16px;
    font-face: PingFangSC;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: 0;
    paragraph-spacing: 0;
    text-align: left;
    width: 100%;
    box-sizing: border-box;
  }
  .qrcode-box{
    width: 355px;
    height: 355px;
    background: #FFF8ED;
    border: 1px solid #FFC134;
    border-radius: 20px;
    margin-top: 20px;
  }
  .qrcode{
    width: 247px;
    height: 244px;
    margin-top: 40px;
  }
  .qrcode-txt{
    width: 84px;
    height: 17px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #8B5A13;
    text-align: right;
    margin-top: 30px;
  }
  .button-link{
    width: 355px;
    height: 45px;
    background-image: linear-gradient(1deg, #E09D59 0%, #F1DAB9 100%);
    border-radius: 23px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    line-height: 45px;
    margin-top: 25px;
  }
  .button-save{
    width: 355px;
    height: 45px;
    border: 1px solid #E5AF76;
    border-radius: 23px;
    margin-top: 15px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #E2A363;
    text-align: center;
    line-height: 45px;
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/version-iphone.vue